import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BrowserClient, Hub } from '@sentry/browser';
export class Sentry {
  constructor(dsn) {
    _defineProperty(this, "hub", void 0);
    _defineProperty(this, "configureForExercise", exercise => {
      const {
        environment,
        id,
        user
      } = exercise;
      this.hub.configureScope(scope => {
        scope.setTag('environment', environment.toLocaleLowerCase());
        if (id != null) {
          scope.setTag('exerciseId', id.toString());
        }
        if ((user === null || user === void 0 ? void 0 : user.id) != null) {
          scope.setUser({
            id: user === null || user === void 0 ? void 0 : user.id.toString()
          });
        }
      });
    });
    _defineProperty(this, "captureError", (error, extra) => {
      this.hub.withScope(scope => {
        scope.setExtra('extra', extra);
        this.hub.captureException(error);
      });
    });
    _defineProperty(this, "captureErrorCurr", extra => error => this.captureError(error, extra));
    _defineProperty(this, "setEnvironment", environment => {
      this.hub.configureScope(scope => {
        scope.setTag('environment', environment.toLocaleLowerCase());
      });
    });
    const client = new BrowserClient({
      dsn
    });
    this.hub = new Hub(client);
  }
}